module.exports = __webpack_public_path__ + "img/locales.798f50a8.svg";